import { render, staticRenderFns } from "./SurveyPlaceDetail.vue?vue&type=template&id=535e9a8b"
import script from "./SurveyPlaceDetail.vue?vue&type=script&lang=js"
export * from "./SurveyPlaceDetail.vue?vue&type=script&lang=js"
import style0 from "./SurveyPlaceDetail.vue?vue&type=style&index=0&id=535e9a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports